import { useRouter } from 'next/navigation';
import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { Loader } from '@/components/ui/Loader';
import { useAuth } from '@/providers/AuthProvider';
import { Button } from '@/styled/button.styled';
import { LoginContainer } from '@/styled/common';
import { useTheme } from '@/styled/themes/ThemeProvider/useTheme';
import { ButtonVariants } from '@/types/styled';

interface ChatWrapperProps {
  children: React.ReactNode;
}

export const ChatWrapper = ({
  children
}: PropsWithChildren<ChatWrapperProps>) => {
  const { t } = useTranslation();
  const { isAuthReady, isAuthenticated } = useAuth();
  const { theme } = useTheme();
  const router = useRouter();

  if (!isAuthReady) return <Loader isFull />;

  if (!isAuthenticated && isAuthReady) {
    return (
      <LoginContainer>
        <div>You are not authorized. Please log in</div>
        <Button
          $variant={ButtonVariants.Filled}
          $color={theme.system.blue}
          onClick={() => router.replace('/login')}
        >
          {t('signIn')}
        </Button>
      </LoginContainer>
    );
  }

  return <>{children}</>;
};
